import { useEffect, useState } from 'react'
import PageHeading from '../../components/PageHeading'
import { BookOutlined } from '@ant-design/icons';
import axiosInstance from '../../utils/axios';
import { useLocation } from "react-router-dom";
import MovieCard from '../../components/dashboard/MovieCard';
import CustomerSeatLayout from '../../components/reserve/CustomerSeatLayout';
import { Button, Alert } from 'antd';

const Reservation = () => {
    // const navigate = useNavigate();
    const { state } = useLocation();
    const [loading, setLoading] = useState(false);
    const [screen, setScreen] = useState({});
    const [selectedSeats, setSelectedSeats] = useState([]);

    useEffect(() => {
        console.log(state);
        fetchSeatLayout();
    }, [state]);

    const fetchSeatLayout = async () => {
        setLoading(true);
        try {
            const showId = state?.show?.id;
            const theatreId = state?.show?.theatre;
            const screentId = state?.show?.screen;
            const dateId =  state?.selected_slot?.date_id;
            const slotId = state?.selected_slot?.timeslot?.id;

            const { data } = await axiosInstance.get(
                `booking/screen/${showId}/theatre/${theatreId}/screen/${screentId}/date/${dateId}/slot/${slotId}/`
            );
            setScreen({
                sections: data?.screen?.sections || [],
                bookedSeats: data?.bookedSeats || [],
                reservedSeats: [],
                reservation: data?.reservation || []
            });
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleToggle = (seat) => {
        setSelectedSeats((prev) => {
            const found = prev.includes(seat.id);
            return found ? prev.filter((id) => id !== seat.id) : [...prev, seat.id];
        });
    };

    const reserveSeat = async () => {
        if (selectedSeats.length === 0) {
            alert("Select at least one seat");
            return;
        }

        const showId = state?.show?.id;
        const dateId =  state?.selected_slot?.date_id;
        const slotId = state?.selected_slot?.timeslot?.id;
        const totalPrice = 0;

        const reservationData = {
            show: showId,
            show_date: dateId,
            show_time_slot: slotId,
            number_of_seats: selectedSeats.length,
            seats: selectedSeats,
            amount_to_pay: totalPrice.toFixed(2),
        }

        try {
            await axiosInstance.post('/booking/reserve-seats', reservationData);
            alert("Selected seats reserved successfully");
            // navigate("");
        } catch (err) {
            alert("Cannot reserve seat");
        }
    }

    const removeReservation = async (bookingId, seat) => {
        try {
            await axiosInstance.delete(`/booking/remove-reserved-seats/${bookingId}/${seat.id}`);
            alert("Selected seat's reservation removed");
            fetchSeatLayout();
        } catch (err) {
            console.error(err);
            alert("Cannot remove reservation");
        }
    }

    return (
        <div className="dashboard">
            {!loading ? <>
                <PageHeading name="Seat Reservation" icon={<BookOutlined />} />
                <MovieCard currentMovie={state?.movie} currentShow={state?.show}/>
                <h3>Selected Date: {state?.selected_slot?.date}</h3>
                <h3>Selected Time: {state?.selected_slot?.timeslot?.timeslot_title}</h3>
                <h4>Duration: {state?.selected_slot?.timeslot?.timeslot_start} To {state?.selected_slot?.timeslot?.timeslot_end}</h4>
                <Alert
                    message="Very Important"
                    description="Make sure seat reservation done before customers starts to book ticket. Because we Cannot implement seat locking mechanism without payment logic. Reservation must done before normal booking start"
                    type="info"
                    showIcon
                />
                <CustomerSeatLayout
                    reservations={screen.reservation || []}
                    sections={screen.sections || []}
                    selected={selectedSeats}
                    bookedSeats={screen.bookedSeats || []}
                    onToggle={handleToggle}
                    onRemove={removeReservation}
                />
                <div style={{ width: "100%", backgroundColor: "#ccc", padding: "6px", textAlign: "center", marginTop: "10px"}}>Screen</div>
                <br/>
                <Button variant='solid' color='green' onClick={reserveSeat}>Reserve </Button>
            </> : <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh", // only half the page for "Please Wait"
        }}
      >
        <h4>Please Wait...</h4>
      </div>}
        </div>
    )
}

export default Reservation